import React, {useContext} from "react";
import {useLocation} from "react-router-dom";
import {DispatchOrder} from "../../types/DispatchOrder";
import {GlobalContext} from "../admin-frame/AdminFrame";
import {ActivitySubRows} from "../dispatch-orders/ActivitySubRows";
import {Constants} from "../common/Constants";

interface JobDetailDispatchOrderBoxProps {
    dispatchOrder: DispatchOrder;
}

export let JobDetailDispatchOrderBox = function (props: JobDetailDispatchOrderBoxProps) {
    let context = useContext(GlobalContext);
    let location = useLocation();
    let dispatchOrder = props.dispatchOrder;

    let totalTruckCount = dispatchOrder.total_truck_count;
    let totalTruckCountPadded = totalTruckCount.toString().padStart(2, "0");
    let truckCountStyle: React.CSSProperties | undefined = totalTruckCount === 0 ? {visibility: "hidden"} : undefined;

    let statusName = dispatchOrder.dispatch_order_status.name;
    let statusModifierClass = statusName.toLowerCase().replace(/\s+/g, "-");
    let statusLetter = statusName.charAt(0).toUpperCase();

    function handleClick() {
        let from = encodeURIComponent(location.pathname + location.search);
        context.navigator.navigateTo(`/dispatch/dispatch-orders/${dispatchOrder.id}?from=${from}`);
    }

    let statusCircle: React.ReactNode = null;
    if (statusName !== Constants.dispatchOrderStatusNames.confirmed) {
        statusCircle = (
            <div className={`job-detail-dispatch-order-status-circle ${statusModifierClass}`}>
                <div className="job-detail-dispatch-order-status-circle-text">
                    {statusLetter}
                </div>
            </div>
        );
    }

    return (
        <div className="job-detail-dispatch-order-box" data-dispatch-order-id={dispatchOrder.id} onClick={handleClick}>
            <div className="job-detail-dispatch-order-box-activities">
                <ActivitySubRows activities={dispatchOrder.activities}/>
            </div>
            <div className="job-detail-dispatch-order-box-truck-count" style={truckCountStyle}>
                {totalTruckCountPadded}
            </div>
            <div className="job-detail-dispatch-order-box-action-arrow">
                <img src="/static/images/chevron-right-green.svg" alt=""/>
            </div>
            {statusCircle}
        </div>
    );
};
